(function($){

    'use strict';

    theme.AssetsLoader.onPageLoaded(function() {
        var mySiblings = $("#my-siblings");

        var dataCollection = mySiblings.attr('data-collection');
        var split = dataCollection && dataCollection.split('?');
        var collection = split && split[0];
        var params = split && split[1] ? split[1].split('&') : [];
        var datas = params.reduce((a, p) => {
            let t = p.split('=');
            return {
                ...a,
                [t[0]]: t[1]
            }
        }, {});

        $.ajax({
            type: 'GET',
            url: theme.routes.root_url + 'collections/' + collection,
            cache: false,
            data: {
                ...datas,
                view: 'siblings'
            },
            dataType: 'html',
            success: function (data) {
                mySiblings.html(data);
                mySiblings.find('[data-product-id="' + mySiblings.attr('data-product-id') + '"]')
                    .addClass("active")
                    .find('a').removeAttr('href');
            }
        });
});
})(jQueryTheme);